import React from 'react';
import ReportsTableSummary, { allAppsWidth } from "../../Common/ReportsTableSummary";
import { getReportColumnsForSeries } from "../CloudChurnOrRenewals.utils";
export default function CloudConversionSummary(props) {
  const {
    datasets,
    reportName
  } = props;
  const reportColumns = getReportColumnsForSeries(datasets, reportName);
  const summary = [{
    head: 'All apps',
    width: "".concat(allAppsWidth, "%")
  }];
  reportColumns.forEach(column => summary.push({
    head: column.key,
    content: column.content,
    width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
  }));
  return /*#__PURE__*/React.createElement(ReportsTableSummary, {
    summary: summary
  });
}